// @ts-ignore
import type {IApiResponsePaymentMethod} from "@/interfaces/apiResponseInterfaces/IApiResponsePaymentMethod.interface";
import type {IPaymentMethod} from "@/interfaces/IPaymentMethod.interface";
import {PaymentMethods} from "../interfaces/enums/PaymentMethods.enum";

export default class apiDataService
{
    /**
     * @param data
     */
    static preparePaymentMethods(data: IApiResponsePaymentMethod[]): IPaymentMethod[] {
        return data.map((item) => {
            let logoUrl = item.logo_url;

            let useCustomLogoUrl = false;

            switch (item.key) {
                case PaymentMethods.SWEDBANK:
                case PaymentMethods.BANK_TRANSFER:
                case PaymentMethods.CARD:
                case PaymentMethods.LUMINOR:
                case PaymentMethods.SIAULIU:
                case PaymentMethods.SEB:
                case PaymentMethods.PAYSERA:
                case PaymentMethods.CASH:
                case PaymentMethods.LTHAND:
                case PaymentMethods.CREDIT_CONTRACT:
                    useCustomLogoUrl = true;
                    break;
            }

            if (useCustomLogoUrl) {
                logoUrl = '/assets/images/payment-methods/' + item.key + '.svg';
            }

            let titleNextToLogo:string|null = null;

            switch (item.key) {
                case PaymentMethods.BANK_TRANSFER:
                    titleNextToLogo = 'key_bank_transfer';
                    break;

                case PaymentMethods.CASH:
                    titleNextToLogo = 'key_cash';
                    break;

                case PaymentMethods.CREDIT_CONTRACT:
                    titleNextToLogo = 'key_credit_contract';
                    break;
            }

            return {
                key: item.key,
                title: item.title,
                currency: item.currency,
                logoUrl,
                titleNextToLogo,
                minAmount: item.min_amount,
                maxAmount: item.max_amount,
                provider: item.provider ? item.provider : null,
                selected: false
            } as IPaymentMethod;
        });
    }
}